import { Box } from '@mui/material'
import BlockUserActionButton from './BlockUserActionButton'
import { IUser } from 'types/models/User'

interface Props {
  id: string;
  refetch?: () => void;
  user: IUser;
}

export default function UserActionButtons({ id, refetch, user }: Props) {
  return (
    <Box
      display={'flex'}
      gap={1}
    >
      <BlockUserActionButton refetch={refetch} user={user} />
    </Box>
  )
}
